// extracted by mini-css-extract-plugin
export default {"loader":"LoaderButton_loader__JYbcE","loader-container":"LoaderButton_loader-container__xruz4","spin89345":"LoaderButton_spin89345__HHGwx"};